import {
  ekycApprovalMessageTypes,
  ekycPendingMessageTypes,
  registerMessageTypes,
  shahkarMessageTypes,
} from '../constants';
import {
  openAccountAlreadyExistsBottomsheet,
  openAccountInvalidShahkarBottomsheet,
  openDuplicatePhoneNumberBottomsheet,
  openEditSejamInfoBottomsheet,
  openEkycApprovalBottomsheet,
  openPendingValidationBottomsheet,
} from '../components';
import { TRedirectData } from '../types';

interface IHandleRegisterMessagesParams {
  redirectData: TRedirectData;
  handleRegisterLogic: (__redirectData: TRedirectData) => void;
}

const { AccountExist, DuplicateMobile, EditSejamData } = registerMessageTypes;

export const useRegisterMessages = () => {
  const handleRegisterMessages = ({
    redirectData,
    handleRegisterLogic,
  }: IHandleRegisterMessagesParams) => {
    const messageType = redirectData?.message?.messageType || '';

    if (messageType === AccountExist) {
      openAccountAlreadyExistsBottomsheet(redirectData, handleRegisterLogic);
    } else if (messageType === DuplicateMobile) {
      openDuplicatePhoneNumberBottomsheet(redirectData, handleRegisterLogic);
    } else if (messageType === EditSejamData) {
      openEditSejamInfoBottomsheet(redirectData);
    } else if (shahkarMessageTypes.includes(messageType)) {
      openAccountInvalidShahkarBottomsheet(redirectData, handleRegisterLogic);
    } else if (ekycPendingMessageTypes.includes(messageType)) {
      openPendingValidationBottomsheet(redirectData);
    } else if (ekycApprovalMessageTypes.includes(messageType)) {
      openEkycApprovalBottomsheet(redirectData);
    }
  };

  const isMessageDefined = (redirectData: TRedirectData) => {
    const messageData = redirectData?.message;
    const isInvalidState = redirectData?.invalidState;

    const shouldShowMessage =
      messageData &&
      Object?.hasOwn(registerMessageTypes, messageData?.messageType || '') &&
      !isInvalidState;

    return shouldShowMessage;
  };

  return {
    handleRegisterMessages,
    isMessageDefined,
  };
};
